import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';

import { configure } from 'mobx';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

configure({ enforceActions: 'never' });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
